// @flow

import React from 'react';
import { Label, FormGroup } from 'reactstrap';

import { CustomSelect } from '../../../../../components/FormikElements';

const NATIONALITY_OPTIONS = [
  { value: 'NP', title: 'Nepali' },
  { value: 'IN', title: 'Indian' },
  { value: 'US', title: 'Other' },
];

export default function NationalityInput() {
  return (
    <FormGroup>
      <Label className="title">Nationality</Label>
      <div className="input-group">
        <CustomSelect
          name="nationality"
          options={NATIONALITY_OPTIONS}
          className="form-control"
        />
      </div>
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/SearchForm/FormElements/Nationality.js